/* eslint-disable */
import React, {useState, useEffect} from 'react'
import {Alert, Button, Modal, Spinner, Table, Form} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {
  digitalPlanetImportInvoices,
  selectDigitalPlanetImportLoading,
} from '../../../redux/slices/digitalplanetinvoice.slice'

function formatDate(dateStr) {
  if (!dateStr) return '-'
  const d = new Date(dateStr)
  return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`
}

function ProjectAssignModal({show, selectedItems, onDone, onClose}) {
  const dispatch = useDispatch()
  const importLoading = useSelector(selectDigitalPlanetImportLoading)
  const projectLookupList = useSelector((state) => state.lookup.projectLookupList)

  const [projectIds, setProjectIds] = useState({})
  const [validationErrors, setValidationErrors] = useState({})
  const [apiError, setApiError] = useState(null)

  useEffect(() => {
    const initial = {}
    selectedItems.forEach((inv) => {
      initial[inv.uuid] = ''
    })
    setProjectIds(initial)
    setValidationErrors({})
    setApiError(null)
  }, [selectedItems])

  const allProjectsSelected = selectedItems.every(
    (inv) => projectIds[inv.uuid] && Number(projectIds[inv.uuid]) > 0
  )

  const handleProjectChange = (uuid, value) => {
    setProjectIds((prev) => ({...prev, [uuid]: value}))
    if (value) {
      setValidationErrors((prev) => {
        const next = {...prev}
        delete next[uuid]
        return next
      })
    }
  }

  const handleSubmit = async () => {
    const errors = {}
    selectedItems.forEach((inv) => {
      if (!projectIds[inv.uuid] || Number(projectIds[inv.uuid]) <= 0) {
        errors[inv.uuid] = 'Proje seçimi zorunludur.'
      }
    })
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors)
      return
    }

    setApiError(null)
    const body = {
      items: selectedItems.map((inv) => ({
        uuid: inv.uuid,
        invoiceId: inv.invoiceId,
        senderName: inv.senderName,
        senderTaxId: inv.senderTaxId,
        receiverTaxId: inv.receiverTaxId,
        payableAmount: inv.payableAmount,
        currency: inv.currency,
        issueDate: inv.issueDate,
        paymentDueDate: inv.paymentDueDate || null,
        documentTypeCode: inv.documentTypeCode,
        profileId: inv.profileId,
        direction: inv.direction,
        allowanceAmount: inv.allowanceAmount || 0,
        chargeAmount: inv.chargeAmount || 0,
        taxTotalAmount: inv.taxTotalAmount || 0,
        projectId: Number(projectIds[inv.uuid]),
      })),
    }

    try {
      const result = await dispatch(digitalPlanetImportInvoices(body)).unwrap()
      onDone(result)
    } catch (err) {
      setApiError(err?.message || 'Servise bağlanılamadı. Lütfen tekrar deneyin.')
    }
  }

  return (
    <Modal show={show} onHide={!importLoading ? onClose : undefined} size='xl' centered>
      <Modal.Header closeButton={!importLoading}>
        <Modal.Title>İçeri Aktarılacak Faturalar ({selectedItems.length} adet)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {apiError && <Alert variant='danger'>{apiError}</Alert>}

        <div className='table-responsive'>
          <Table bordered hover className='align-middle'>
            <thead className='bg-light'>
              <tr>
                <th>Fatura No</th>
                <th>Gönderen Firma</th>
                <th>Gönderen VKN</th>
                <th>Fatura Tarihi</th>
                <th className='text-end'>Tutar</th>
                <th style={{minWidth: 200}}>Proje</th>
              </tr>
            </thead>
            <tbody>
              {selectedItems.map((inv) => (
                <tr key={inv.uuid} style={importLoading ? {opacity: 0.6} : {}}>
                  <td>{inv.invoiceId || '-'}</td>
                  <td>{inv.senderName || '-'}</td>
                  <td>{inv.senderTaxId || '-'}</td>
                  <td>{formatDate(inv.issueDate)}</td>
                  <td className='text-end'>
                    {Number(inv.payableAmount).toLocaleString('tr-TR', {
                      minimumFractionDigits: 2,
                    })}{' '}
                    {inv.currency}
                  </td>
                  <td>
                    <Form.Select
                      value={projectIds[inv.uuid] || ''}
                      onChange={(e) => handleProjectChange(inv.uuid, e.target.value)}
                      disabled={importLoading}
                      isInvalid={!!validationErrors[inv.uuid]}
                    >
                      <option value=''>Proje seçin...</option>
                      {(projectLookupList || []).map((p) => (
                        <option key={p.id} value={p.id}>
                          {p.name}
                        </option>
                      ))}
                    </Form.Select>
                    {validationErrors[inv.uuid] && (
                      <div className='text-danger small mt-1'>{validationErrors[inv.uuid]}</div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              {Object.entries(
                selectedItems.reduce((acc, inv) => {
                  const cur = inv.currency || 'TRY'
                  acc[cur] = (acc[cur] || 0) + (inv.payableAmount || 0)
                  return acc
                }, {})
              ).map(([currency, total], i, arr) => (
                <tr key={currency} className='fw-bold bg-light'>
                  <td colSpan={4} className={i === 0 ? 'text-end' : 'text-end border-top-0'}>
                    {i === 0 ? 'Toplam Tutar' : ''}
                  </td>
                  <td className='text-end'>
                    {total.toLocaleString('tr-TR', {minimumFractionDigits: 2})} {currency}
                  </td>
                  <td />
                </tr>
              ))}
            </tfoot>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='light' onClick={onClose} disabled={importLoading}>
          İptal
        </Button>
        <Button
          variant='primary'
          onClick={handleSubmit}
          disabled={!allProjectsSelected || importLoading}
        >
          {importLoading ? (
            <>
              <Spinner animation='border' size='sm' className='me-2' />
              Aktarılıyor...
            </>
          ) : (
            'İçeri Aktar'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export {ProjectAssignModal}
